// extracted by mini-css-extract-plugin
export default {"FloatIcon":"Index_FloatIcon__JfMX-","TopIcon":"Index_TopIcon__RKRf4","Zap":"Index_Zap__SSp0J","zap-icon":"Index_zap-icon__U1Z-K"};